<template>
  <div class="active-facet">
    <p
      v-for="fieldId in Object.keys(selectedFacets)"
      v-if="selectedFacets[fieldId].length > 0 && ((showCatalogueDetails === (fieldId !== 'catalog')) || !showCatalogueDetails)"
      :key="fieldId"
    >
      <span v-if="fieldId === 'geocodingDescription'">{{ $t('message.datasetFacets.facets.geocodingdescription') }}: </span>
      <span v-if="fieldId === 'legalBase'">{{ $t('message.datasetFacets.facets.legalbase') }}: </span>
      <span v-if="fieldId === 'keywords'">{{ $t('message.datasetFacets.facets.keywords') }}: </span>
      <span v-if="fieldId === 'format'"> Formate: </span>
      <span v-if="fieldId === 'minDate'">Startmonat: </span>
      <span v-if="fieldId === 'maxDate'">Endmonat: </span>
      <span v-if="fieldId === 'type'">Art der Statistik: </span>
      <!-- {{ `${findFacetFieldTitle(fieldId)}:` }}  -->
      <span
        v-for="(facetId, i) in selectedFacets[fieldId]"
        :key="i"
        class="badge badge-pill badge-highlight mr-1"
      >
        <span
          v-if="fieldId === 'minDate' || 'maxDate'"
        >
          {{ findFacetDateTitle(fieldId,facetId) }}
        </span>
        <span
          v-else
        >
          {{ findFacetTitle(fieldId, facetId) }}
        </span>
        <span
          class="close-facet ml-2"
          @click="removeSelectedFacet(fieldId, facetId)"
        >&times;</span>
      </span>
    </p>
    <b-button
      v-if="showResetFilters()"
      class="d-inline-block"
      right
      text="Filter zurücksetzen"
      size="sm"
      variant="primary"
      @click="resetFilters()"
    >Filter zurücksetzen</b-button>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { getFacetTranslation } from '@/utils/helpers';

  export default {
    name: 'SelectedFacetsOverview',
    components: {},
    props: {
      selectedFacets: {
        required: true,
      },
    },
    data() {
      return {
        availableFacets: [],
        showCatalogueDetails: false,
        months: [ "Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember" ]
      };
    },
    computed: {
      ...mapGetters('datasets', [
        'getAvailableFacets',
      ]),
      showCatalogDetailsWatcher() {
        return this.$route.query.showcataloguedetails;
      },
    },
    watch: {
      showCatalogDetailsWatcher: {
        handler(showCatalogDetails) {
          this.showCatalogueDetails = showCatalogDetails;
        },
      },
    },
    created() {
      this.initShowCatalogueDetails();
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods: {
      findFacetTitle(fieldId, facetId) {
        try {
          const facetTitle = this.getAvailableFacets.find(field => field.id === fieldId).items.find(facet => facet.id === facetId).title;
          return getFacetTranslation(fieldId, facetId, this.$i18n.locale, facetTitle);
        } catch {
          return facetId;
        }
      },
      findFacetDateTitle(fieldId, facetId) {
        try {
          const facetTitle = this.getAvailableFacets.find(field => field.id === fieldId).items.find(facet => facet.id === facetId).title;
          return getFacetTranslation(fieldId, facetId, this.$i18n.locale, facetTitle);
        } catch {
          const arr = facetId.split("-")
          const year = arr[0]
          const month_index = parseInt(arr[1],10) - 1;
          return this.months[month_index] + ' ' + year
        }
      },
      findFacetFieldTitle(fieldId) {
        try {
          return this.getAvailableFacets.find(field => field.id === fieldId).title;
        } catch {
          return fieldId;
        }
      },
      removeSelectedFacet(field, facet) {
        this.toggleFacet(field, facet);
        this.resetPage();
        this.$nextTick(() => {
          this.$emit('update-data');
        });
      },
      resetPage() {
        this.$router.replace({ query: Object.assign({}, this.$route.query, { page: 1 }) });
      },
      /**
       * @description Add/Remove a facet from the routers query parameters.
       * @param field - The field of the facet
       * @param facet - The given facet
       */
      toggleFacet(field, facet) {
        if (!Object.prototype.hasOwnProperty.call(this.$route.query, [field])) {
          this.$router.push({ query: Object.assign({}, this.$route.query, { [field]: [] }) });
        }
        let facets = this.$route.query[field].slice();
        if (!Array.isArray(facets)) facets = [facets];
        const index = facets.indexOf(facet);
        if (index > -1) {
          facets.splice(index, 1);
        } else {
          facets.push(facet);
        }
        this.$router.push({ query: Object.assign({}, this.$route.query, { [field]: facets }) });
      },
      initShowCatalogueDetails() {
        const showCatalogueDetails = this.$route.query.showcataloguedetails;
        if (showCatalogueDetails === 'true') {
          this.showCatalogueDetails = true;
        } else this.showCatalogueDetails = false;
      },
      showResetFilters() {
        for (let facet in this.selectedFacets) {
          if (Object.keys(this.selectedFacets[facet]).length > 0) return true;
        }
        return false;
      },
      resetFilters() {
        this.$router.replace({ query: Object.assign({}, { lang: this.$route.query.lang, page: 1 }) });
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/styles/bootstrap_theme';

  .close-facet {
    cursor: pointer;
  }

  .active-facet {
    margin-top: 13px;
  }
</style>
